export default __webpack_public_path__ + "static/media/logo-dpia-black.7cd2501b.png";